<div id="testimonial">

    <div class="container">
        <div class="text-center" id="testimonial-title">
            <h2>WHAT PARENT SAYS</h2>
            <hr>
        </div>
        <div class="carousel slide" id="slide4" data-ride="carousel">
            <!-- Indicator -->
            <ol class="carousel-indicators">
                <li class="active indicator" data-target="#slide4"
                data-slide-to="0"></li>
                <li class="indicator" data-target="#slide4" data-slide-to="1"></li>
            </ol>
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <div class="row d-flex">
                        <div class="col-lg-6">
                            <div id="testimonial-detail">
                                <img appLazyload src="/assets/img/testimonial/test1.jpeg" alt="person1" class="img-fluid">
                                <div id="main-content">
                                    <span><i class="fas fa-quote-left"></i></span>
                                    <h4>Siddharth Sachdeva</h4>
                                    <p>A very good school for any student's personal growth and everything becomes memorable when you have experienced the time in a place like this.</p>
                                    <span><i class="fas fa-quote-right float-right"></i></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div id="testimonial-detail">
                                <img appLazyload src="/assets/img/testimonial/test2.jpg" alt="person1" class="img-fluid">
                                <div id="main-content">
                                    <span><i class="fas fa-quote-left"></i></span>
                                    <h4>Ram Pal Mittan</h4>
                                    <p>Good school, surrounding Panipat, qualified staff, building sports ground are spacious. Lush green parks with plenty of plants. All facilities are available required far as school. </p>
                                    <span><i class="fas fa-quote-right float-right"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="carousel-item">
                    <div class="row d-flex">
                        <div class="col-lg-6">
                            <div id="testimonial-detail">
                                <img appLazyload src="/assets/img/testimonial/test3.jpg" alt="person1" class="img-fluid">
                                <div id="main-content">
                                    <span><i class="fas fa-quote-left"></i></span>
                                    <h4>Atul Gupta</h4>
                                    <p>It's one of the best school in town Panipat and ever stood first in Academics as well as in Sports. Here students and mentors plays vital role in any type of activity enthusiastically.</p>
                                    <span><i class="fas fa-quote-right float-right"></i></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div id="testimonial-detail">
                                <img appLazyload src="/assets/img/testimonial/test4.jpg" alt="person1" class="img-fluid">
                                <div id="main-content">
                                    <span><i class="fas fa-quote-left"></i></span>
                                    <h4>Sahil Panchal</h4>
                                    <p>Suprb arrangments, loving teachers and principal Ajay sir style awesome <br>
                                        Thanks for the alumini meet <br>
                                        Thanks a lot for reunion</p>
                                    <span><i class="fas fa-quote-right float-right"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button class="carousel-control-prev" type="button" data-target="#slide4" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </button>
              <button class="carousel-control-next" type="button" data-target="#slide4" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </button>
        </div>
        
    </div>
    
</div>